<template>
  <div>
    <div class="max-w-[60ch]">
      <UtilityText :text="$t('dbc-cancel-contract-error-unknown-entry')" />

      <div class="mt-s">
        <p class="mt-[8px] font-neo-screen-head">
          <strong> Name:</strong>
          {{ formData?.firstName }} {{ formData?.lastName }}
        </p>

        <p class="mt-[8px] font-neo-screen-head">
          <strong>{{ messageCustomerNumber }}:</strong>
          {{ formData?.customerNumber }}
        </p>

        <p class="mt-[8px] font-neo-screen-head">
          <strong>{{ messageEmail }}:</strong>
          {{ formData?.email }}
        </p>
      </div>

      <div class="mt-s">
        <p>
          <strong class="font-neo-screen-head">{{ messageNoteLabel }}:</strong>
          {{ messageNoteText }}
        </p>
      </div>

      <div class="mt-s">
        <small>{{ messageGreetings }}</small>
      </div>
    </div>

    <UtilityButton
      class="mt-[24px] mb-[160px]"
      :button="{
        type: 'ghost',
        link: getPagePath['home']![locale]!,
        text: $t('dbc-button-return-to-home'),
      }"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  formData: CancelContractData | null
}>()

const { t, locale } = useI18n()

const client = useRuntimeConfig().public.client
const clientMap = useRuntimeConfig().public.clientMapping as ClientMapping

const messageCustomerNumber = t('dbc-cancel-contract-input-number-label')

const messageEmail = t('dbc-cancel-contract-input-email-label')

const messageNoteLabel = t('dbc-cancel-contract-error-note-label')

const messageNoteText = t('dbc-cancel-contract-error-note-text')

const messageGreetings = ref(t('dbc-text-greetings-from-us'))
messageGreetings.value = messageGreetings.value!.replace(
  '[placeholder]',
  clientMap[client]!
)
</script>
